import React from "react";
import clsx from "clsx";
import type { EcoConsumptionDisclaimerAreaType } from "../types/EcoConsumptionType";
import styles from "./SpecEcoConsumption.module.scss";
import SanitizedRenderer from "../../../../common-deprecated/components/SanitizedRenderer";

export const DisclaimerEcoConsumptionArea: React.FC<EcoConsumptionDisclaimerAreaType> = (props) => {
    const { title, subtitle, generalDisclaimer, disclaimers } = props;
    return (
        <div className={clsx(styles.wrapper, styles.disclaimer)}>
            {title && <h4 className={styles.title}>{title}</h4>}
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
            {generalDisclaimer && <SanitizedRenderer as="div" html={generalDisclaimer} />}
            {disclaimers.length && (
                <ol>
                    {disclaimers.map((disclaimer, index) => (
                        <SanitizedRenderer as="li" key={`eco-consumption-disclaimer-${index + 1}`} html={disclaimer} />
                    ))}
                </ol>
            )}
        </div>
    );
};
